"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSwitch = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
var classnames_1 = require("../util/classnames");
var swipeable_1 = require("../swipeable");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var ToggleSwitch = /** @class */function (_super) {
  __extends(ToggleSwitch, _super);
  function ToggleSwitch() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      checked: typeof _this.props.checked !== 'undefined' ? _this.props.checked : _this.props.defaultChecked
    };
    _this.isChecked = function () {
      return typeof _this.props.checked !== 'undefined' ? _this.props.checked : _this.state.checked;
    };
    _this.handleSwipe = function (newValue) {
      if (_this.isChecked() !== newValue) {
        // TODO: Fix this - can't find where the 'label' ref is created
        // eslint-disable-next-line react/no-string-refs
        react_dom_1.default.findDOMNode(_this.refs['label']).click();
      }
    };
    _this.handleRightSwipe = function () {
      _this.handleSwipe(true);
    };
    _this.handleLeftSwipe = function () {
      _this.handleSwipe(false);
    };
    _this.handleChange = function (e) {
      var value = e.target.checked;
      if (_this.props.disabled) {
        return;
      }
      if (typeof _this.props.checked === 'undefined') {
        _this.setState({
          checked: value
        }, function () {
          if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
          }
        });
      } else {
        if (typeof _this.props.onChange === 'function') {
          _this.props.onChange(value);
        }
      }
    };
    return _this;
  }
  ToggleSwitch.prototype.componentWillReceiveProps = function (nextProps) {
    if (typeof nextProps.checked !== 'undefined' && nextProps.checked !== this.state.checked) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };
  ToggleSwitch.prototype.render = function () {
    var _a;
    var _b = this.props,
      id = _b.id,
      className = _b.className,
      tabIndex = _b.tabIndex,
      children = _b.children,
      name = _b.name,
      disabled = _b.disabled,
      required = _b.required,
      checkedLabel = _b.checkedLabel,
      uncheckedLabel = _b.uncheckedLabel,
      autoFocus = _b.autoFocus;
    var checked = this.isChecked();
    var customProps = _1.omit(this.props, Object.keys(ToggleSwitch.propTypes));
    var toggleSwitchClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('toggle-switch')] = true, _a[vdl_prefix_1.vdlPrefix('toggle-switch--checked')] = checked, _a[vdl_prefix_1.vdlPrefix('toggle-switch--disabled')] = disabled, _a[vdl_prefix_1.vdlPrefix('toggle-switch--required')] = required, _a);
    return react_1.default.createElement(swipeable_1.Swipeable, {
      onSwipedRight: this.handleRightSwipe,
      onSwipedLeft: this.handleLeftSwipe
    }, react_1.default.createElement("label", __assign({}, customProps, {
      htmlFor: id,
      className: classnames_1.classNames(className, toggleSwitchClasses)
    }), react_1.default.createElement("input", {
      id: id,
      type: "checkbox",
      autoFocus: autoFocus,
      tabIndex: disabled ? -1 : tabIndex || 0,
      onChange: this.handleChange,
      checked: checked,
      name: name,
      "aria-disabled": disabled,
      disabled: disabled
    }), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('toggle-switch__container')
    }, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('toggle-switch__toggle')
    }, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('toggle-switch__slide')
    }, react_1.default.createElement("div", {
      className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('toggle-switch__label'), vdl_prefix_1.vdlPrefix('toggle-switch__label--checked'))
    }, checkedLabel), react_1.default.createElement("div", {
      className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('toggle-switch__label'), vdl_prefix_1.vdlPrefix('toggle-switch__label--unchecked'))
    }, uncheckedLabel), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('toggle-switch__knob')
    }))), react_1.default.createElement("span", null, children))));
  };
  ToggleSwitch.propTypes = {
    id: prop_types_1.default.string,
    autoFocus: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    checked: prop_types_1.default.bool,
    defaultChecked: prop_types_1.default.bool,
    checkedLabel: prop_types_1.default.node,
    uncheckedLabel: prop_types_1.default.node,
    name: prop_types_1.default.string,
    className: prop_types_1.default.string,
    tabIndex: prop_types_1.default.number,
    children: prop_types_1.default.node
  };
  ToggleSwitch.defaultProps = {
    autoFocus: false,
    disabled: false,
    required: false,
    defaultChecked: false
  };
  return ToggleSwitch;
}(react_1.default.PureComponent);
exports.ToggleSwitch = ToggleSwitch;